export class BookedPoojaInvoiceJson {
    list: Array<PoojaBookedJson>;
    message: string;
    refNo: string;
}
export class PoojaBookedJson {
    billDate: string;
    bookedOn: string;
    poojaTime: string;
    devoteeDetailList: Array<DevoteeDetail>;
    invoiceId: number;
    invoiceNumber: string;
    separateInvoiceSeries?: boolean;
    lastInvoiceNumber: string;
    lastSeparateSeriesInvoiceNumber: string;
    invoiceTotal: number;
    paidAmount: number;
    paymentId: number;
    poojaName: string;
    note: string;
    property?: string;
    deityName?: string;
    templeDistrict?: string;
    voucherNo?:string;
    paymentMode?:string;
    chequeNo?:string;
    printType?:string;
    poojaBookingDetail?: Array<PoojaBookingDetail>; // Ajesh Added for pooja enquiry re-print
}
export class DevoteeDetail {
    amount: number;
    devoteeAddress: string;
    devoteeName: string;
    devoteePhone: string;
    devoteeStar: string;
    age: string;
    quantity: number;
    rate: number;
    unit: string;
    deityName?: string;
    poojaName: string;
    relation?: string;
}

export class MarriageDetail {
    brideName: string;
    brideAddress: string;    
    bridePhone: string;
    brideStar: string;
    brideDob: Date;
    groomName: string;
    groomAddress: string;    
    groomPhone: string;
    groomStar: string;
    groomDob: Date;
    brideFatherName: string;
    brideMotherName: string;
    groomFatherName: string;
    groomMotherName: string;
    marriageDate: string;
    invoiceDate: string;
    poojaTime: string;
    total: number;
    notes: string;
    time: string;
    templeDistrict: string;
    voucherNo: string;
}

//Ajesh Added for Enquiry re-print
export class PoojaBookingDetail {
    quantity: number;
    rate: number;
    amount: number;
    billDate: string;
    bookedOn: string;
    poojaTime: string;
    devoteeList: Array<DevoteeDetail>;
    invoiceId: number;
    invoiceNumber: string;
    separateInvoiceSeries?: boolean;
    lastInvoiceNumber: string;
    lastSeparateSeriesInvoiceNumber: string;
    invoiceTotal: number;
    paidAmount: number;
    paymentId: number;
    poojaName: string;
    note: string;
    property?: string;
    deityName?: string;
    templeDistrict?: string;
    voucherNo?:string;
    paymentMode?:string;
    chequeNo?:string;
    printType?:string;
}

